import { HttpHelper } from '@helpers/http.helper';
import { ModelOffer, ModelOfferJson } from '@models/model-offer';

export interface ContractAnnexModelModelOfferJson {
  id?: number;
  offer_model?: Partial<ModelOfferJson>;
}

export class ContractAnnexModelModelOffer {
  constructor(
    public id?: number,
    public modelOffer?: ModelOffer
  ) {}

  static fromJson(json: Partial<ContractAnnexModelModelOfferJson>): ContractAnnexModelModelOffer {
    return new ContractAnnexModelModelOffer(json.id, json.offer_model ? ModelOffer.fromJson(json.offer_model) : null);
  }

  static toJson(model: ContractAnnexModelModelOffer): ContractAnnexModelModelOfferJson {
    return {
      id: model.id,
      offer_model: model.modelOffer ? HttpHelper.toJsonId(model.modelOffer) : null
    };
  }
}
